import React from "react";
import PropTypes from "prop-types";
import { kebabCase } from "lodash";
import { Helmet } from "react-helmet";
import { graphql, Link } from "gatsby";
import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";

// eslint-disable-next-line
export const EventsPostTemplate = ({
  content,
  contentComponent,
  description,
  tags,
  title,
  helmet,
  startdatetime,
  enddatetime,
  location,
  onlineEvent,
}) => {
  const PostContent = contentComponent || Content;

  return (
    <section className="section">
      {helmet || ""}
      <div className="container content">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
              {title}
            </h1>
            <p>{description}</p>
            <p>
              {startdatetime && startdatetime.length ? (<><strong>Start Date & Time</strong>: {(new Date(startdatetime)).toString()} <br /></>) : null}
              {enddatetime && enddatetime.length ? (<><strong>End Date & Time:</strong> {(new Date(enddatetime)).toString()} <br /></>) : null}
            {
              location ? (
                <><strong>Location:</strong><address>{location}</address></>
              ) : null
            }
            {
              onlineEvent && onlineEvent.medium ? (
                <>
                  <strong>Online Event:</strong> via {onlineEvent.medium}
                </>
              ) : null
            }
            </p>
            <PostContent content={content} />
            {tags && tags.length ? (
              <div style={{ marginTop: `4rem` }}>
                <h4>Tags</h4>
                <ul className="taglist">
                  {tags.map((tag) => (
                    <li key={tag + `tag`}>
                      <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

EventsPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
};

const EventsPost = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout 
      pageTitle={post.frontmatter.title}
      pageDescription={post.frontmatter.description}
      pageSlug={post.fields.slug}
      pageImage={post.frontmatter.featuredimage ? post.frontmatter.featuredimage.childImageSharp.gatsbyImageData.images.fallback.src : null}
    >
      <EventsPostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        helmet={
          <Helmet titleTemplate="%s | Events">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
        startdatetime={post.frontmatter.startdatetime}
        enddatetime={post.frontmatter.enddatetime}
        location={post.frontmatter.location}
        onlineEvent={post.frontmatter.onlineevent}
      />
    </Layout>
  );
};

EventsPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default EventsPost;

export const pageQuery = graphql`
  query EventsPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        featuredimage {
          childImageSharp {
            gatsbyImageData(width: 400, quality: 64, layout: CONSTRAINED)
          }
        }
        date(formatString: "MMMM DD, YYYY")
        title
        description
        tags
        startdatetime
        enddatetime
        location
        onlineevent {
          medium
        }
      }
    }
  }
`;
